import { signal, Signal } from '@angular/core';
import {
  DocumentAttribute,
  DocumentTypeExtended,
  EditDocument,
  EditDocumentDialog,
} from '../types';
import { TaskInstance } from '@data-access/tasks';
import { DialogSize } from '@wcg/frontend-framework';
import { SubmissionResponse } from '@data-access/submissions';
import environment from '@environments/environment';

export function createEditDocumentDialogPayload(params: {
  $documents: Signal<EditDocument[]>;
  $tasks: Signal<TaskInstance[]>;
  $documentTypes: Signal<DocumentTypeExtended[]>;
  $attributeTypes?: Signal<DocumentAttribute[]>;
  $includeAdditionalFields?: Signal<boolean>;
  $canCloseDialog: Signal<boolean>;
  submission: Partial<SubmissionResponse>;
  updateDocument: (data: {
    document: EditDocument;
    submission: Partial<SubmissionResponse>;
  }) => void;
  dialogTitle?: string;
  dialogSize?: DialogSize;
}): EditDocumentDialog {
  return {
    $attributeTypes: params.$attributeTypes,
    $canCloseDialog: params.$canCloseDialog,
    $documentTypes: params.$documentTypes,
    $documents: params.$documents,
    $includeAdditionalFields: params.$includeAdditionalFields,
    $taskEnabled: signal(environment.enabledTask),
    $tasks: params.$tasks,
    callBacks: {
      updateDocument: params.updateDocument,
    },
    dialogSize: params.dialogSize ?? DialogSize.MEDIUM,
    dialogTitle: params.dialogTitle ?? 'Edit Document',
    submission: params.submission,
  };
}
